import React, { Dispatch } from 'react';

import { close, down } from '@/assets/icons';
import { GetVideoQuery } from '@/graphql';
import { ButtonBase, SvgIcon } from '@material-ui/core';
import { pathOr } from 'ramda';

import { IconButton } from '../IconButton';
import { VideoSynopsis } from '../VideoSynopsis';
import styles from './PlayerHeader.module.scss';

// import { UpNext } from './UpNext/UpNext';

interface PlayerHeaderProps {
	video: GetVideoQuery['getVideo'];
	synopsisShown: boolean;
	onClick: () => void;
	onCloseClick: () => void;
	chatOpen: boolean;
	// isDevotion: boolean;
	upNextShown: boolean;
	setUpNextShown: Dispatch<boolean>;
	displayRightColumn: boolean;
}

export const PlayerHeader: React.FC<PlayerHeaderProps> = ({
	video,
	synopsisShown,
	onClick,
	onCloseClick,
	chatOpen,
	// isDevotion,
	upNextShown,
	setUpNextShown,
	displayRightColumn,
}: PlayerHeaderProps) => {
	const videoCollections = pathOr(
		[],
		['videoCollections', 'videos', 'items'],
		video,
	);

	return (
		<header className={styles['player-header']}>
			{!upNextShown && (
				<>
					<div className={styles['player-header__wrapper']}>
						<div
							className={styles['player-header__title-container']}
						>
							{/* {isDevotion && (
								<h2
									className={
										styles['player-header__devotion-title']
									}
								>
									{video?.devotionTitle}
								</h2>
							)} */}
							<ButtonBase
								component={'span'}
								className={
									styles['player-header__title-wrapper']
								}
								onClick={onClick}
							>
								<h1 className={styles['player-header__title']}>
									{video.name}
									<SvgIcon
										component={down}
										className={
											synopsisShown
												? `${styles['player-header__title-icon']} ${styles['player-header__title-icon--rotated']}`
												: styles[
														'player-header__title-icon'
												  ]
										}
									/>
								</h1>
							</ButtonBase>
						</div>
						{!displayRightColumn && (
							<div className={styles['player-header__action']}>
								<IconButton
									icon={close}
									color="transparent"
									onClick={onCloseClick}
									size="medium"
								/>
							</div>
						)}
					</div>
					<div className={styles['player-header__synopsis']}>
						<VideoSynopsis
							synopsisShown={synopsisShown}
							authorName={video.contributor?.name ?? 'Asaph'}
							authorRole={
								video.contributor?.role ??
								'The Worship Team Platform'
							}
							authorAvatar={
								video.contributor?.imageUrl ?? undefined
							}
							description={video.description}
							// TOADO RB: we don't support it
							// tags={['Hello', 'World']}
						/>
					</div>
				</>
			)}
			{/* {!chatOpen &&
				!synopsisShown &&
				!isDevotion &&
				videoCollections.length > 1 && (
					<UpNext
						variant="mobile"
						videos={videoCollections}
						currentlyWatched={video?.id}
						collectionName={pathOr('', ['videoCollections', 'name'], video)}
						open={upNextShown}
						setOpen={setUpNextShown}
					/>
				)} */}
		</header>
	);
};
